import { render, staticRenderFns } from "./RolesTab.vue?vue&type=template&id=15d6a92f&scoped=true"
import script from "./RolesTab.vue?vue&type=script&lang=ts"
export * from "./RolesTab.vue?vue&type=script&lang=ts"
import style0 from "./RolesTab.vue?vue&type=style&index=0&id=15d6a92f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d6a92f",
  null
  
)

export default component.exports